import { render, staticRenderFns } from "./AppyList.vue?vue&type=template&id=6be64bb6&scoped=true&"
import script from "./AppyList.vue?vue&type=script&lang=js&"
export * from "./AppyList.vue?vue&type=script&lang=js&"
import style0 from "./AppyList.vue?vue&type=style&index=0&id=6be64bb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be64bb6",
  null
  
)

export default component.exports